import { useState, useRef, useEffect } from 'react';
import { Lock } from 'lucide-react';

export function HoldToUnlock({ onUnlock }: { onUnlock: () => void }) {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const startHold = () => {
    setProgress(0);
    intervalRef.current = setInterval(() => {
      setProgress(p => {
        if (p >= 100) {
          clearInterval(intervalRef.current!);
          onUnlock();
          return 100;
        }
        return p + 2; // 50 ticks of 100ms = 5s
      });
    }, 100);
  };

  const stopHold = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setProgress(0);
  };

  return (
    <button 
      onPointerDown={(e) => { e.stopPropagation(); startHold(); }}
      onPointerUp={(e) => { e.stopPropagation(); stopHold(); }}
      onPointerLeave={(e) => { e.stopPropagation(); stopHold(); }}
      className="relative p-1 px-4 rounded hover:bg-[#00d9ff]/20 text-[#00d9ff] transition-colors overflow-hidden flex items-center justify-center min-w-[80px]"
      title="Segure por 5s para desbloquear"
    >
      <div 
        className="absolute bottom-0 left-0 h-full bg-[#00d9ff]/30 pointer-events-none transition-all duration-100 ease-linear" 
        style={{ width: `${progress}%` }} 
      />
      <Lock size={12} className="relative z-10 mr-2" />
      <span className="text-[10px] uppercase font-bold relative z-10">{Math.floor(progress)}%</span>
    </button>
  );
}
